<mat-card>
    <form>
        <mat-card-header>
            <mat-card-title class="mat-card-title-custom">
                <span>{{ (isUser ? "import_file.add_user_by_file" :
                    "import_file_customer.add_customer_by_file") | translate }}</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="mb-3 mat-card-content-contract-sm">
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel [expanded]="viewMode !== 'view'" class="mb-3 mt-3" [disabled]="viewMode !== 'view'">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);">
                            {{ "title.infor_file" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-group row">
                        <div class="col-12">
                            <table>
                                <tr>
                                    <td>{{ (isUser ? "import_file.file_name" : "import_file_customer.file_name") |
                                        translate }}<span style="color: #fc1203">*</span>
                                    </td>

                                    <td>
                                        <span [matTooltip]="documentTypeEnterprise?.name">{{
                                            documentTypeEnterprise?.name }}</span>
                                    </td>
                                    <td *ngIf="fileName" style="max-width: 75vw;" class="pr-3">
                                        <span class="file-name" [class.error-file]="errorFile"
                                            style="word-break: break-word">{{
                                            fileName
                                            }}</span>
                                    </td>
                                    <td *ngIf="viewMode == 'create'">
                                        <input type="file" id="file" name="file" style="display: none"
                                            (change)="onChangeFile($event)" accept=".xlsx"
                                            onclick="this.value = null" />
                                        <button mat-raised-button color="primary" type="button" (click)="uploadFile()" appTrackEvent="w.btn.danh_sach_kh.them_tu_file.cho_tep"
                                            *ngIf="!fileName">
                                            <mat-icon class="mr-0" style="vertical-align: middle;width: auto;
                                            height: auto;">cloud_upload</mat-icon>
                                            {{ "button.choose_file" | translate }}
                                        </button>
                                        <button color="primary" mat-stroked-button type="button" (click)="uploadFile()" appTrackEvent="w.btn.danh_sach_kh.them_tu_file.cho_tep"
                                            *ngIf="fileName">
                                            <mat-icon class="mr-0" style=" vertical-align: middle; width: auto;
                                            height: auto;">cloud_upload</mat-icon>
                                            {{ "button.choose_another_file" | translate }}
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div style="display: block; height: 15px; width: 100%"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span style="font-weight: 600; white-space: no-wrap;
                                        font-size: 12px;" class="mr-4">(
                                            <a (click)="downFileTemplateExcelAddUser($event)" class="file-name"
                                                style="text-decoration: underline;">{{
                                                (isUser ? "contract_lot.note_for_upload" : "contract_lot.note_for_upload_use_area_old") | translate
                                                }}</a>)
                                        </span>
                                    </th>
                                    <td colspan="3">
                                        <i style="font-size: 12px;">{{
                                            "hint.attach_accept_customer_from_file" | translate
                                            }}</i>
                                    </td>
                                </tr>
                                <tr *ngIf="!isUser">
                                    <th>
                                        <span style="font-weight: 600; white-space: no-wrap;
                                        font-size: 12px;" class="mr-4">(
                                            <a (click)="downFileTemplateExcelAddUser($event,true)" class="file-name"
                                                style="text-decoration: underline;">{{
                                                "contract_lot.note_for_upload_use_area_new" | translate
                                                }}</a>)
                                        </span>
                                    </th>
                                </tr>
                                <tr>
                                    <td colspan="4">
                                        <div style="display: block; height: 30px; width: 100%"></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel expanded="true" class="mb-3" *ngIf="viewMode === 'view'" disabled>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title">
                            <div class="row" style="width: 100%">
                                <div class="col-3 title-panel">
                                    {{ (isUser ? "import_file.list_user_import" :
                                    "import_file_customer.list_customer_import") | translate }}
                                </div>
                                <div class="col-9 d-flex justify-content-between" *ngIf="processing">
                                    <div class=" title-panel">{{ "import_file.user_processing" | translate }}
                                        ({{ processing.percent ? processing.percent : 0 }}%) </div>
                                    <div class="d-flex flex-column justify-content-center"
                                        style="width: calc(100% - 200px);">
                                        <mat-progress-bar mode="determinate" [value]="processing.percent"
                                            [bufferValue]="100"></mat-progress-bar>
                                    </div>
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="contract-lot-detail">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-between">
                                <div>
                                    <b>{{ "import_file.user_code" | translate }}:</b>
                                    <!-- {{
                                    contractLot && contractLot.code ? contractLot.code : null
                                    }} --> {{fileCode}}
                                </div>
                                <div class="d-flex">
                                    <div class="mr-4">
                                        <b>{{ "contract_lot.total_contract" | translate }}:</b>
                                        {{ renderNumber("total") }}
                                    </div>
                                    <div class="mr-4">
                                        <b>{{ "contract_lot.contract_success" | translate }}:</b>
                                        {{ renderNumber("success") }}
                                    </div>
                                    <div>
                                        <b>{{ "contract_lot.contract_error" | translate }}:</b>
                                        {{ renderNumber("error") }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 d-flex justify-content-between pt-4">
                                <p class="font-weight-bold">
                                    {{ "contract_lot.result" | translate }}
                                </p>
                                <a class="file-result" *ngIf="!processing" (click)="getResultFile()">{{
                                    "contract_lot.download_result_file" | translate
                                    }}</a>
                            </div>
                            <div class="col-12">
                                <nz-table #rowsTable nzBordered [nzData]="nzData" [nzShowPagination]="false"
                                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                                    <thead>
                                        <tr>
                                            <th class="text-center" nzWidth="55px">
                                                {{ "import_file.table_detail.index" | translate }}
                                            </th>

                                            <th class="text-center" nzWidth="15%" *ngIf="!isUser">
                                                {{ "import_file.table_detail.page_in_excel" | translate }}
                                            </th>

                                            <th class="text-center" nzWidth="8%">
                                                {{ "import_file.table_detail.line_in_excel" | translate }}
                                            </th>
                                            <th class="text-center" nzWidth="16%" nzEllipsis="true">
                                                {{
                                                (isUser ? "import_file.table_detail.fulName" :
                                                "import_file_customer.table_detail.user_name")| translate
                                                }}
                                            </th>
                                            <th class="text-center" nzWidth="10%">
                                                {{
                                                (isUser ? "import_file.table_detail.user_name" :
                                                "import_file_customer.table_detail.certNumber") | translate
                                                }}
                                            </th>
                                            <th class="text-center" nzWidth="15%">
                                                {{ "import_file.table_detail.status" | translate }}
                                            </th>
                                            <th class="text-center">
                                                {{
                                                "import_file.table_detail.error_detail" | translate
                                                }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of nzData; let i = index; trackBy:identify">
                                            <td class="text-center">{{ i + 1 }}</td>
                                            <!-- <td class="text-center">
                        <span *ngIf="data.customerType === 'PERSONAL'">{{
                          "contract_lot.customer_type.personal" | translate
                        }}</span>
                        <span *ngIf="data.customerType === 'ENTERPRISE'">{{
                          "contract_lot.customer_type.enterprise" | translate
                        }}</span>
                      </td> -->
                                            <td class="text-center" *ngIf="!isUser">
                                                {{ data.sheet ? data.sheet : null }}
                                            </td>

                                            <td class="text-center">
                                                {{ data.orderNo ? data.orderNo : null }}
                                            </td>
                                            <td>
                                                {{isUser ? ( (data.data && data.data.fullName) ? data.data.fullName :
                                                null) : ( (data.data && data.data.name) ? data.data.name : null) }}
                                            </td>
                                            <td nz-tooltip
                                                [nzTooltipTitle]="isUser ? data.data.username: data.data.certificateNo">
                                                {{isUser ? ( (data.data && data.data.username) ? (data.data.username |
                                                slice:0:30) : null) : ( (data.data && data.data.certificateNo) ?
                                                data.data.certificateNo : null) }}<span
                                                    *ngIf="isUser && data.data && data.data.username && data.data.username.length > 30">...</span>
                                            </td>
                                            <td class="text-center">
                                                <span [ngStyle]="renderStatusColor(data.status)" class="p-1">{{
                                                    renderStatus(data.status) }}</span>
                                            </td>
                                            <td nz-tooltip [nzTooltipTitle]="data.errorMessage">
                                                {{ data.errorMessage ? (data.errorMessage| slice:0:50) : null }}<span
                                                    *ngIf="data.errorMessage && data.errorMessage.length > 50">...</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </nz-table>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <div class="pr-0 ">
                    <div class="text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
                        <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button" appTrackEvent="w.btn.danh_sach_kh.them_tu_file.huy_bo"
                            *ngIf="viewMode === 'create'" (click)="onClickCancel()">
                            <mat-icon class="mr-0">cancel</mat-icon>
                            {{ "button.cancel" | translate }}
                        </button>
                        <button mat-raised-button color="primary" class="mr-3" type="button" (click)="submit()" appTrackEvent="w.btn.danh_sach_kh.them_tu_file.them_kh"
                            *ngIf="viewMode === 'create'" [disabled]="!fileName">
                            <mat-icon class="mr-0">save</mat-icon>
                            {{ (isUser ? "button.add_user" : "button.add_customer") | translate }}
                        </button>
                    </div>
                </div>
            </mat-accordion>
        </mat-card-content>
    </form>
</mat-card>
